import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusrentalbelgaum() {



    const cardData = {




keyword: "Mini Bus Rental Belgaum",

headingDescription: "Belgaum Taxi Service offers reliable mini bus rental in Belgaum for group travel, corporate transportation, school trips, college tours, wedding functions, pilgrimage tours, family outings, and sightseeing packages. Our mini bus rental service is designed for passengers who need comfortable and spacious transportation for medium-sized groups. We provide well-maintained mini buses with experienced drivers, ensuring safe, smooth, and convenient travel for local as well as outstation journeys. Whether you require a mini bus for a one-day trip, multi-day tour, event transportation, employee travel, or group transfers, we offer flexible rental options according to your requirements. Our services include doorstep pickup, comfortable seating, luggage space, transparent pricing, punctual service, and 24/7 customer support. Belgaum Taxi Service provides mini bus rental facilities for destinations across Karnataka, Goa, Maharashtra, and nearby states, making group transportation easy, affordable, and hassle-free.",

topPlaces: [
  {
    title: "Kittur",
    description: "Kittur is a historical destination near Belgaum known for Kittur Fort and the legacy of Rani Chennamma. It is a popular location for educational tours and group visits."
  },
  {
    title: "Badami",
    description: "Badami is famous for its ancient cave temples, sandstone cliffs, and Chalukyan architecture. It is an excellent destination for heritage tours with groups and families."
  },
  {
    title: "Aihole",
    description: "Aihole is a historic village known for ancient temples and remarkable architectural structures. It attracts students, history lovers, and group travelers."
  },
  {
    title: "Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site featuring beautiful temples and historical monuments, making it a preferred destination for cultural tours."
  },
  {
    title: "Bijapur",
    description: "Bijapur is known for historical landmarks like Gol Gumbaz, ancient architecture, and cultural attractions, making it suitable for group sightseeing trips."
  },
  {
    title: "Shravanabelagola",
    description: "Shravanabelagola is a famous Jain pilgrimage destination known for the Gomateshwara statue and religious significance. Groups often prefer mini buses for comfortable travel."
  },
  {
    title: "Chikmagalur",
    description: "Chikmagalur is a beautiful hill station famous for coffee plantations, waterfalls, trekking spots, and scenic mountain views, ideal for group vacations."
  },
  {
    title: "Sakleshpur",
    description: "Sakleshpur is a peaceful hill destination known for green landscapes, plantations, trekking trails, and nature experiences, making it perfect for group getaways."
  },
  {
    title: "Kudremukh",
    description: "Kudremukh is a scenic mountain destination famous for forests, trekking routes, and natural beauty. It is a popular choice for adventure and nature groups."
  },
  {
    title: "Mangalore",
    description: "Mangalore is a coastal city known for beaches, temples, seafood, and cultural attractions. Mini bus rentals provide convenient transportation for large groups visiting the city."
  }
],




"services": [
  {
    "name": "Mini Bus on Rent in Belgaum",
    "description": "Book Mini Bus on Rent in Belgaum for comfortable and reliable group transportation services across local and outstation destinations. Our spacious AC mini buses are perfect for family trips, corporate travel, wedding functions, school tours, college trips, airport transfers, sightseeing, and group events. Enjoy well-maintained vehicles, professional drivers, flexible rental plans, affordable pricing, luggage space, comfortable seating, and safe travel experience with 24x7 booking assistance."
  },
  {
    "name": "Mini Bus Rent in Belgaum",
    "description": "Choose Mini Bus Rent in Belgaum for convenient and budget-friendly transportation solutions for small and large groups. We provide clean AC mini buses with experienced chauffeurs for city travel, business meetings, family outings, religious tours, and outstation journeys. Get reliable pickup, comfortable rides, transparent pricing, and hassle-free booking options."
  },
  {
    "name": "Mini Bus Rental Belgaum",
    "description": "Hire Mini Bus Rental Belgaum services for group tours, corporate transportation, wedding guest movement, school trips, and vacation travel. Our rental mini buses offer comfortable seating, safety features, professional drivers, and flexible rental durations to make every journey smooth and enjoyable."
  },
  {
    "name": "Mini Bus Hire Belgaum",
    "description": "Book Mini Bus Hire Belgaum for private and commercial travel requirements with premium vehicles and experienced drivers. Whether you need transportation for events, family functions, office travel, or long-distance trips, our mini bus hire service provides comfort, reliability, and affordable travel solutions."
  },
  {
    "name": "Mini Bus Booking Belgaum",
    "description": "Complete Mini Bus Booking Belgaum for comfortable group transportation with easy reservations and flexible travel options. Our mini buses are suitable for airport transfers, sightseeing tours, corporate events, weddings, and outstation trips with professional chauffeur service and timely pickup."
  },
  {
    "name": "Mini Bus Service Belgaum",
    "description": "Choose Mini Bus Service Belgaum for safe and comfortable transportation for families, companies, schools, colleges, and tour groups. We offer well-maintained mini buses with trained drivers, affordable packages, and reliable service for local and long-distance travel."
  },
  {
    "name": "AC Mini Bus on Rent Belgaum",
    "description": "Book AC Mini Bus on Rent Belgaum for a comfortable journey with air-conditioned interiors, spacious seating, and professional drivers. Ideal for summer trips, corporate travel, weddings, airport transfers, and sightseeing tours with affordable rental options."
  },
  {
    "name": "Luxury Mini Bus Rental Belgaum",
    "description": "Experience premium travel with Luxury Mini Bus Rental Belgaum featuring comfortable interiors, modern facilities, spacious seating, and professional chauffeur services. Perfect for corporate events, family celebrations, wedding transportation, and luxury group tours."
  },
  {
    "name": "Mini Bus with Driver Belgaum",
    "description": "Hire Mini Bus with Driver Belgaum for stress-free travel with experienced chauffeurs who ensure safe and smooth journeys. Our driver-operated mini buses are available for local trips, outstation travel, corporate transportation, and special occasions."
  },
  {
    "name": "Mini Bus for Outstation Belgaum",
    "description": "Book Mini Bus for Outstation Belgaum for comfortable long-distance travel to popular destinations with family, friends, or groups. Enjoy spacious seating, luggage capacity, experienced drivers, affordable packages, and reliable highway transportation."
  },
  {
    "name": "Mini Bus for Family Trip Belgaum",
    "description": "Choose Mini Bus for Family Trip Belgaum for comfortable vacations, pilgrimages, sightseeing, and weekend getaways. Travel together with your family in spacious vehicles with safe driving, flexible routes, and convenient pickup options."
  },
  {
    "name": "Mini Bus for Group Tour Belgaum",
    "description": "Book Mini Bus for Group Tour Belgaum for sightseeing packages, holiday tours, and group adventures. Our mini buses provide comfortable seating, professional drivers, affordable rental plans, and reliable transportation for memorable journeys."
  },
  {
    "name": "Mini Bus for Wedding Belgaum",
    "description": "Hire Mini Bus for Wedding Belgaum for smooth guest transportation during wedding ceremonies and events. Provide your guests with comfortable travel, punctual service, clean vehicles, and professional drivers for hassle-free movement."
  },
  {
    "name": "Corporate Minibus Rental Belgaum",
    "description": "Choose Corporate Minibus Rental Belgaum for employee transportation, business meetings, office events, and corporate travel requirements. Our reliable fleet ensures punctual pickup, comfortable seating, professional service, and efficient employee mobility solutions."
  },
  {
    "name": "Mini Bus for Picnic Belgaum",
    "description": "Book Mini Bus for Picnic Belgaum for enjoyable group outings with friends, families, schools, and organizations. Travel comfortably with spacious seating, experienced drivers, and affordable packages designed for relaxing journeys."
  },
  {
    "name": "Mini Bus for School Trip Belgaum",
    "description": "Choose Mini Bus for School Trip Belgaum for safe student transportation with trained drivers, comfortable seating, and reliable travel arrangements. Ideal for educational tours, excursions, and school group activities."
  },
  {
    "name": "Mini Bus for College Trip Belgaum",
    "description": "Book Mini Bus for College Trip Belgaum for student tours, educational visits, and group excursions. Enjoy affordable transportation with comfortable vehicles, experienced chauffeurs, and flexible travel plans."
  },
  {
    "name": "Tourist Mini Bus Belgaum",
    "description": "Hire Tourist Mini Bus Belgaum for sightseeing tours, holiday packages, and group travel. Our tourist mini buses provide comfortable seating, safe journeys, professional drivers, and convenient travel options for exploring destinations."
  },
  {
    "name": "MiniBus Airport Transfer Belgaum",
    "description": "Book MiniBus Airport Transfer Belgaum for convenient airport pickup and drop services for groups. Enjoy timely transportation, comfortable seating, luggage space, professional drivers, and reliable airport travel solutions."
  },
  {
    "name": "One Way Minibus Belgaum",
    "description": "Choose One Way Minibus Belgaum for affordable single-trip transportation with fixed pricing, comfortable vehicles, and professional drivers. Suitable for airport drops, outstation journeys, events, and group travel requirements."
  },
  {
    "name": "Round Trip MiniBus Belgaum",
    "description": "Book Round Trip MiniBus Belgaum for return journeys with flexible schedules, affordable packages, and comfortable transportation. Ideal for family tours, corporate trips, sightseeing, and group travel."
  },
  {
    "name": "Best Mini Bus Rental Belgaum",
    "description": "Select the Best Mini Bus Rental Belgaum for premium vehicles, experienced drivers, affordable rates, and dependable transportation services. We provide customized travel solutions for families, businesses, and groups."
  },
  {
    "name": "Affordable Mini Bus Rental Belgaum",
    "description": "Get Affordable Mini Bus Rental Belgaum with competitive pricing, comfortable vehicles, and reliable chauffeur services. Perfect for budget-friendly group travel, events, tours, and outstation transportation."
  },
  {
    "name": "Cheap Mini Bus on Rent Belg",
    "description": "Book Cheap Mini Bus on Rent Belg for economical group transportation without compromising comfort and safety. Enjoy affordable rental plans, clean vehicles, professional drivers, and reliable service."
  },
  {
    "name": "Tourist Tempo Traveller Belgaum",
    "description": "Hire Tourist Tempo Traveller Belgaum for family vacations, sightseeing tours, and group travel. Get spacious seating, comfortable interiors, experienced drivers, and affordable packages for memorable journeys."
  },
  {
    "name": "Best Tempo Traveller Belgaum",
    "description": "Choose Best Tempo Traveller Belgaum for premium group transportation with modern facilities, comfortable seating, AC options, and professional chauffeur service for local and outstation trips."
  },
  {
    "name": "Cheap Tempo Traveller Belgaum",
    "description": "Book Cheap Tempo Traveller Belgaum for affordable group travel with comfortable vehicles, reliable drivers, and flexible rental options for tours, family trips, and events."
  },
  {
    "name": "12 Seater Mini Bus on Rent Belgaum",
    "description": "Rent 12 Seater Mini Bus on Rent Belgaum for small group travel, family outings, corporate trips, and sightseeing tours. Enjoy comfortable seating, professional drivers, and affordable rental services."
  },
  {
    "name": "15 Seater Mini Bus on Rent Belgaum",
    "description": "Book 15 Seater Mini Bus on Rent Belgaum for group tours, events, office transportation, and outstation journeys with spacious interiors, experienced chauffeurs, and reliable travel service."
  }
],

"tableData": [
  ["Mini Bus on Rent in Belgaum", "Mini Bus Rent in Belgaum"],
  ["Mini Bus Rental Belgaum", "Mini Bus Hire Belgaum"],
  ["Mini Bus Booking Belgaum", "Mini Bus Service Belgaum"],
  ["AC Mini Bus on Rent Belgaum", "Luxury Mini Bus Rental Belgaum"],
  ["Mini Bus with Driver Belgaum", "Mini Bus for Outstation Belgaum"],
  ["Mini Bus for Family Trip Belgaum", "Mini Bus for Group Tour Belgaum"],
  ["Mini Bus for Wedding Belgaum", "Corporate Minibus Rental Belgaum"],
  ["Mini Bus for Picnic Belgaum", "Mini Bus for School Trip Belgaum"],
  ["Mini Bus for College Trip Belgaum", "Tourist Mini Bus Belgaum"],
  ["MiniBus Airport Transfer Belgaum", "One Way Minibus Belgaum"],
  ["Round Trip MiniBus Belgaum", "Best Mini Bus Rental Belgaum"],
  ["Affordable Mini Bus Rental Belgaum", "Cheap Mini Bus on Rent Belg"],
  ["Tourist Tempo Traveller Belgaum", "Best Tempo Traveller Belgaum"],
  ["Cheap Tempo Traveller Belgaum", "12 Seater Mini Bus on Rent Belgaum"],
  ["15 Seater Mini Bus on Rent Belgaum", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mini Bus Rental in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service provides comfortable mini bus rental solutions for group travel, corporate events, family functions, sightseeing tours, and outstation journeys."
  },
  {
    WhyChooseheading: "Spacious Mini Buses for Group Travel",
    WhyChoosedescription: "Travel together with well-maintained mini buses offering comfortable seating, ample luggage space, and a convenient travel experience for large groups."
  },
  {
    WhyChooseheading: "Perfect for Every Occasion",
    WhyChoosedescription: "Our mini buses are ideal for weddings, corporate outings, school trips, college tours, pilgrimages, family vacations, and group transportation."
  },
  {
    WhyChooseheading: "Pickup Available Across Belgaum",
    WhyChoosedescription: "Get easy pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and other preferred locations with flexible travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Travel",
    WhyChoosedescription: "Our professional drivers ensure safe journeys with excellent route knowledge, punctual service, and comfortable driving experience."
  },
  {
    WhyChooseheading: "Local & Outstation Mini Bus Service",
    WhyChoosedescription: "Hire a mini bus for local sightseeing, business trips, Goa tours, Bangalore travel, Pune journeys, and multi-day group tours."
  },
  {
    WhyChooseheading: "Affordable Rental Packages",
    WhyChoosedescription: "Choose flexible hourly, daily, and long-distance mini bus rental packages with transparent pricing and dependable service."
  },
  {
    WhyChooseheading: "24/7 Booking Assistance",
    WhyChoosedescription: "Book your mini bus rental anytime with quick confirmation and dedicated customer support for smooth group transportation."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Mini Bus Rental in Belgaum?",
    answer: "Yes, we offer mini bus rental services in Belgaum for group travel, events, sightseeing, corporate trips, and outstation journeys."
  },
  {
    question: "What occasions are suitable for mini bus rental?",
    answer: "Mini buses are suitable for weddings, corporate events, school trips, college tours, family functions, pilgrimages, and group vacations."
  },
  {
    question: "How many passengers can travel in a mini bus?",
    answer: "Mini bus seating capacity depends on the vehicle model and requirement. Options are available for small and large groups."
  },
  {
    question: "Can I rent a mini bus for outstation travel from Belgaum?",
    answer: "Yes, mini buses are available for outstation destinations including Goa, Bangalore, Pune, Mumbai, Kerala, and other locations."
  },
  {
    question: "Do you provide drivers with mini bus rental?",
    answer: "Yes, experienced and professional drivers are included with mini bus rental services for safe and comfortable travel."
  },
  {
    question: "Can I hire a mini bus for corporate transportation?",
    answer: "Yes, we provide mini bus services for corporate outings, employee transportation, conferences, and business events."
  },
  {
    question: "Is mini bus rental available for wedding guest transportation?",
    answer: "Yes, mini buses are available for wedding functions, guest pickup, venue transfers, and special events."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, permits, and applicable taxes are generally charged separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Is Mini Bus Rental available 24/7 in Belgaum?",
    answer: "Yes, our mini bus rental service is available throughout the day for planned and urgent travel requirements."
  },
  {
    question: "How can I book a Mini Bus Rental in Belgaum?",
    answer: "Share your travel date, pickup location, destination, passenger count, and trip details to receive a quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback: "We hired a mini bus for our group tour from Belgaum. The vehicle was comfortable, the driver was professional, and the complete journey was managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback: "The mini bus rental service was perfect for our family function. The vehicle was clean, spacious, and the booking process was quick and easy.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus Rental Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/mini-bus-rental-belgaum.webp",
  "description":
    "Book Mini Bus Rental in Belgaum with Belgaum Taxi Service for comfortable group transportation. We provide mini bus hire services for family tours, corporate events, weddings, school trips, and outstation travel with AC mini buses and professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/mini-bus-rental-belgaum"
  }
};




    return (
        <div>




<Helmet>
  <title>Mini Bus Rental Belgaum | Mini Bus Hire Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Mini Bus Rental in Belgaum with Belgaum Taxi Service for reliable group travel solutions. Hire AC mini buses for weddings, corporate events, family tours, school trips, and outstation journeys with experienced drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Mini Bus on Rent in Belgaum, Mini Bus Rent in Belgaum, Mini Bus Rental Belgaum, Mini Bus Hire Belgaum, Mini Bus Booking Belgaum, Mini Bus Service Belgaum, AC Mini Bus on Rent Belgaum, Luxury Mini Bus Rental Belgaum, Mini Bus with Driver Belgaum, Mini Bus Rental Service Belgaum, Mini Bus Hire for Outstation Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Minibusrentalbelgaum;